import React from 'react';
import './SessionExpiredModal.css';

const SessionExpiredModal = ({ open, onClose, onTryRefresh, onGoToLogin }) => {
  if (!open) return null;

  return (
    <div className="session-expired-overlay">
      <div className="session-expired-modal">
        <h3>Sesión expirada</h3>
        <p>Tu sesión ha caducado. ¿Deseas intentar reconectar o ingresar de nuevo?</p>
        <div className="session-expired-actions">
          <button className="btn-try" onClick={onTryRefresh}>Intentar reconectar</button>
          <button className="btn-login" onClick={onGoToLogin}>Ir a login</button>
        </div>
        <button className="session-expired-close" onClick={onClose}>Cerrar</button>
      </div>
    </div>
  );
};

export default SessionExpiredModal;